export default [
  {
    path: "/main/atendimentos/tires",
    meta: {
      tag: "tire",
      name: "Pneus",
      breadcrumb: "Pneus",
      menu: "settings",
    },
    component: () =>
      import(
        /* webpackChunkName: "tires" */ "@/views/main/settings/atendimentos/tires/Tires.vue"
      ),
  },
];
